import React from 'react'

import { withTranslation } from 'react-i18next'

import { ErrorBoundary } from '../../../../../components/ErrorBoundary/ErrorBoundary'
import EventContact from './EventContact/EventContact'

const EventContactsSection = ({ t, contactList }) => {
    const [mediaContact, participantsContact] = contactList
    const mediaContactTitle =
        contactList.length === 1
            ? t('eventDetails.contactSection.title')
            : t('eventDetails.contactSection.mediaTitle')

    return (
        <ErrorBoundary>
            <div className="single-event__contacts">
                <div className="single-event__contacts__list">
                    {mediaContact && (
                        <EventContact contact={mediaContact} title={mediaContactTitle} />
                    )}
                    {participantsContact && (
                        <EventContact
                            contact={participantsContact}
                            title={t('eventDetails.contactSection.participantsTitle')}
                        />
                    )}
                </div>
            </div>
        </ErrorBoundary>
    )
}

export default withTranslation()(EventContactsSection)
